import { Col } from 'antd'
import styled from 'styled-components'

const StyledDishTablePaginationContainer = styled(Col)`
  display: flex;
  justify-content: flex-end;
`

export default StyledDishTablePaginationContainer
